import React from "react";
import { AiOutlineDelete } from "react-icons/ai";
import AddNote from "./AddNote";
import { useSelector, useDispatch } from "react-redux";
import {
  setActiveScreen,
  deleteNotes,
  saveNotes,
  setId,
  getNotes,
  setCurrentNote,
  INoteData,
} from "../../store/reducers/notepad";
import { ITraineeNote } from "../../store/reducers/notepad";
import { AppDispatch, RootState } from "../../store";
import { User } from "models/User";

const ListNote = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { activeScreen, getTraineeNotes } = useSelector(
    (state: RootState) => state.live.notepad
  );

  const { roomId } = useSelector((state: RootState) => state.live.settings);
  const profileData = useSelector((state: any) => state?.auth?.user as User);
  const sessionData = useSelector((state: RootState) => state.live.settings.session);

  const parseNotes = (notesString: string): INoteData => {
    try {
      return JSON.parse(notesString) as INoteData;
    } catch (error) {
      console.error("Failed to parse notes JSON:", error);
      return { title: "", content: "", session_name: "", program_name: "" };
    }
  };

  React.useEffect(() => {
    if (roomId) {
      dispatch(getNotes(parseInt(roomId)));
    }
  }, [roomId, dispatch]);

  React.useEffect(() => {
    if (activeScreen === 1 && roomId) {
      dispatch(getNotes(parseInt(roomId)));
    }
  }, [activeScreen, roomId, dispatch]);

  const handleDeleteNote = (noteId: number) => {
    if (window.confirm("Are you sure you want to delete this note?")) {
      dispatch(deleteNotes(noteId)).then(() => {
        dispatch(getNotes(parseInt(roomId)));
      });
    }
  };

  const onClickNotes = (item: ITraineeNote, noteId: number) => {
    const parsedNotes = parseNotes(item.notes);

    dispatch(setCurrentNote(parsedNotes));
    dispatch(setId(noteId));
    dispatch(setActiveScreen(2));
  };

  return (
    <div className="h-full overflow-y-auto px-4 py-4 text-white font-normal scrollbar-hide">
      <div className="text-base mb-4 text-center">Notepad</div>

      <div className="border border-gray-600 h-full rounded-2xl">
        {activeScreen === 1 ? (
          <div>
            <div className="flex justify-center mb-4 mt-4">
              <button
                onClick={() => {
                  dispatch(
                    setCurrentNote({
                      title: "",
                      content: "",
                      session_name: "",
                      program_name: "",
                    })
                  );
                  dispatch(setId(null));
                  dispatch(setActiveScreen(2));
                }}
                className="bg-[#1e1e2f] text-white px-6 py-2 rounded-full shadow-lg hover:bg-[#2a2a40] transition-all flex items-center gap-2"
                style={{
                  background:
                    "linear-gradient(320.11deg, #2F3339 14.78%, #15181C 95.73%)",
                }}
              >
                Add New Note <span className="text-xs">+</span>
              </button>
            </div>

            {getTraineeNotes.length > 0 ? (
              getTraineeNotes.map((item, index) => {
                const parsedNotes = parseNotes(item.notes);

                return (
                  <div
                    key={index}
                    className="bg-[#32363D] rounded-2xl p-2 mb-4"
                    style={{
                      boxShadow:
                        "-2px -2px 4px 0 rgba(255, 255, 255, 0.25), 2px 2px 4px 0 rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    <div className="flex justify-between items-start">
                      <div
                        onClick={() => onClickNotes(item, item.id)}
                        className="cursor-pointer w-full"
                      >
                        <p className="text-sm text-gray-400 text-right mb-2">
                          {item.created_at.slice(0, 10)}
                        </p>
                        <p className="text-lg font-semibold mb-1">
                          {parsedNotes.title || "Note Title"}
                        </p>
                        <p className="text-sm text-gray-300">
                          {parsedNotes.session_name ||
                            item.sessionSegment.session.program.program_name}
                        </p>
                        <p className="text-sm text-gray-300">
                          {parsedNotes.program_name ||
                            item.sessionSegment.session.session_name}
                        </p>
                      </div>
                      {/* <button
                        onClick={() => handleDeleteNote(item.id)}
                        className="ml-4 text-gray-400 hover:text-red-500 transition-all text-xl"
                      >
                        <AiOutlineDelete />
                      </button> */}
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-center text-gray-500 mt-10">
                Your notes are not created yet!
              </p>
            )}
          </div>
        ) : activeScreen === 2 ? (
          <AddNote />
        ) : null}
      </div>
    </div>
  );
};

export default ListNote;